import { useEffect, useState } from 'react'
import { createConsumer } from '@rails/actioncable'

interface Notification {
  id: number
  title: string
  message: string
  read: boolean
  created_at: string
  data?: any
}

export function useNotifications(userId: number | undefined, schoolId: number | undefined) {
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    if (!userId || !schoolId) return

    // Cria consumer do ActionCable
    const cable = createConsumer()

    // Subscribe ao canal de notificações
    const subscription = cable.subscriptions.create(
      {
        channel: 'NotificationsChannel',
        user_id: userId,
        school_id: schoolId
      },
      {
        received(data: any) {
          if (data.type === 'notification') {
            // Adiciona nova notificação
            setNotifications(prev => [data.notification, ...prev])
            setUnreadCount(prev => prev + 1)
            
            // Toca um som (opcional)
            playNotificationSound()
          }
        }
      }
    )

    // Cleanup quando desmontar
    return () => {
      subscription.unsubscribe()
      cable.disconnect()
    }
  }, [userId, schoolId])

  const playNotificationSound = () => {
    try {
      // Cria e toca um som simples de notificação
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)()
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()

      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)

      oscillator.frequency.value = 800
      oscillator.type = 'sine'

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5)

      oscillator.start(audioContext.currentTime)
      oscillator.stop(audioContext.currentTime + 0.5)
      
      console.log('🔊 Som de notificação tocado!')
    } catch (error) {
      console.error('Erro ao tocar som de notificação:', error)
    }
  }

  return {
    notifications,
    unreadCount,
    setNotifications,
    setUnreadCount
  }
}
